import { writable, derived } from 'svelte/store';
import { getConfiguration } from './AppNetwork';
import type { Configuration } from './AppTypes';

export const configurationStore = writable<Configuration | null>(null);
export const configurationError = writable<string | null>(null);
export const isConfigurationLoaded = derived(configurationStore, ($config) => $config !== null);

export async function loadConfiguration(): Promise<void> {
	try {
		const config = await getConfiguration();
		configurationStore.set(config);
		configurationError.set(null);
	} catch (error) {
		configurationError.set(error instanceof Error ? error.message : 'Failed to load configuration');
	}
}
